export interface BancoBrasilAPI {
  ispb: string;
  name: string;
  code: number | null;
  fullName: string;
  logo_url: string | null;
}

export interface BancoOption {
  value: string;
  label: string;
  nome: string;
  logo?: string;
  codigo: string;
}

const URL_BANCOS = "https://brasilapi.com.br/api/banks/v1";

export async function buscarBancos(): Promise<BancoBrasilAPI[]> {
  const response = await fetch(URL_BANCOS);

  if (!response.ok) {
    throw new Error("Não foi possível carregar a lista de bancos.");
  }

  const bancos: BancoBrasilAPI[] = await response.json();

  return bancos.filter((banco) => banco.code !== null && banco.code !== undefined);
}

export function transformarBancosEmOptions(bancos: BancoBrasilAPI[]): BancoOption[] {
  const mapa = new Map<string, BancoOption>();

  bancos.forEach((banco) => {
    const codigo = String(banco.code).padStart(3, "0");
    const nome = banco.fullName?.trim() || banco.name?.trim();

    if (!nome || mapa.has(codigo)) {
      return;
    }

    mapa.set(codigo, {
      value: codigo,
      label: `${codigo} - ${nome}`,
      nome,
      logo: banco.logo_url ?? undefined,
      codigo,
    });
  });

  return Array.from(mapa.values()).sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));
}

export async function buscarBancosOptions(): Promise<BancoOption[]> {
  const bancos = await buscarBancos();

  return transformarBancosEmOptions(bancos);
}

export function getBankInfo(codigo: string): { nome: string; logo?: string } {
  const codigoNormalizado = String(codigo).replace(/\D/g, "").padStart(3, "0");

  return {
    nome: `Banco ${codigoNormalizado}`,
  };
}